import React, { Component } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import YouTubeShort from '../../../components/YouTubeShort';
import Header from '../../../components/Header';
import SocialMedia from '../../../components/SocialMedia';
import GlassCard from '../../../components/GlassCard';

import './styles.css';

export default class HomeNormalSize extends Component {
  constructor(props) {
    super(props);
    this.state = {
      termsStatus: 'unknown'
    };
  }

  componentDidMount() {
    this.updateTermsStatus();
    window.addEventListener('termsStatusChange', this.updateTermsStatus);
  }

  componentWillUnmount() {
    window.removeEventListener('termsStatusChange', this.updateTermsStatus);
  }

  updateTermsStatus = () => {
    try {
      const storedValue = localStorage.getItem('termsStatus');
      const legacyValue = storedValue === null ? localStorage.getItem('termsAccepted') : null;
      const resolvedValue = storedValue ?? legacyValue;
      if (resolvedValue === 'accepted' || resolvedValue === 'true') {
        this.setState({ termsStatus: 'accepted' });
      } else if (resolvedValue === 'rejected') {
        this.setState({ termsStatus: 'rejected' });
      } else {
        this.setState({ termsStatus: 'unknown' });
      }
    } catch (error) {
      this.setState({ termsStatus: 'unknown' });
    }
  };

  render() {
    const { termsStatus } = this.state;
    const termsRejected = termsStatus === 'rejected';
    return (
      <Container fluid className="fill-height">
        <Header />
        <Row className="fill-height">
          <Col xs={5} md={3} className="panel left-panel">
            <Row className="align-content-between fill-height">
              <Row className="justify-content-md-center">
                <GlassCard className="disclaimer">
                  <h4><b>Welcome to the lab!</b></h4>
                  <br />
                  Think of it as a mix between a workshop, a game room, and a mad scientist’s lab!
                  <br />
                  No rules, no limits... just ideas, experiments, and playful creations to explore.
                  <br />
                  <br />
                  Stay tuned and remember: it's just for fun :)
                </GlassCard>
              </Row>

            </Row>
            <SocialMedia />
          </Col>
          <Col md={9} className="panel right-panel fill-height fill-width" style={{ overflowY: 'auto' }}>
            <div className="experiments-card-container">
              <GlassCard className="experiments-card">
                <h3 className="experiments-title mb-4"><b>Latest Experiments</b></h3>
                <Row className="g-4 justify-content-center w-100">
                  <Col lg={4} md={6} className="d-flex justify-content-center">
                    {termsRejected ? (
                      <div className="terms-blocked">Accept terms to view videos.</div>
                    ) : (
                      <YouTubeShort url="https://www.youtube.com/watch?v=MyrWILMEyXc" />
                    )}
                  </Col>
                  <Col lg={4} md={6} className="d-flex justify-content-center">
                    {termsRejected ? (
                      <div className="terms-blocked">Accept terms to view videos.</div>
                    ) : (
                      <YouTubeShort url="https://www.youtube.com/watch?v=AVBRiYyVmi4" />
                    )}
                  </Col>
                  <Col lg={4} md={6} className="d-flex justify-content-center">
                    {termsRejected ? (
                      <div className="terms-blocked">Accept terms to view videos.</div>
                    ) : (
                      <YouTubeShort url="https://www.youtube.com/watch?v=lFJ40_L4jAk" />
                    )}
                  </Col>
                </Row>
              </GlassCard>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}
